import cached from 'utils/cached';
import Store from 'store/store';


const client = Store.get().client;
const isMobile = (client && !client.isDesktopSize);

const rootMargin = isMobile ? '0px 0px 0px 0px' : '0px 0px -33% 0px';

const getObserver = cached(() => new IntersectionObserver(onUpdate, { rootMargin: rootMargin }));

export function observeScroll(el) {
	getObserver().observe(el);
}

export function unobserveScroll(el) {
	getObserver().unobserve(el);
}

function onUpdate(entries) {
	entries.forEach(entry => {
		const scrolledPast = entry.boundingClientRect.top <= entry.rootBounds.bottom;
		entry.target.toggleAttribute('scrolled-past', scrolledPast);
	});
}